import { companyInfo } from '@/mocks/home';

export default function Footer() {
  const closeModal = () => {
    document.getElementById('policy-modal')?.classList.add('hidden');
  };

  return (
    <>
      <footer className="w-full bg-secondary-100 border-t border-secondary-200">
        <div className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
          <div className="mb-8 md:mb-10">
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-1">
              {companyInfo.name}
            </h3>
            <p className="text-sm text-foreground-600 font-label">
              사이트명: {companyInfo.name} | 상호명: {companyInfo.bizName}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 text-xs md:text-sm text-foreground-700 font-label leading-relaxed">
            <div className="space-y-2">
              <p>
                <strong className="text-foreground-900">대표자:</strong> {companyInfo.ceo}
              </p>
              <p>
                <strong className="text-foreground-900">대표전화:</strong>{' '}
                <a href={`tel:${companyInfo.phone}`} className="text-primary-600 hover:underline">
                  {companyInfo.phone}
                </a>
              </p>
              <p>
                <strong className="text-foreground-900">주소:</strong> {companyInfo.address}
              </p>
            </div>
            <div className="space-y-2">
              <p>
                <strong className="text-foreground-900">사업자등록번호:</strong> {companyInfo.bizNumber}
              </p>
              <p>
                <strong className="text-foreground-900">대부중개업등록번호:</strong> {companyInfo.loanRegNumber}
              </p>
              <p>
                <strong className="text-foreground-900">대부중개업등록기관:</strong> {companyInfo.regAgency} Tel. {companyInfo.regAgencyPhone}
              </p>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-secondary-200">
            <div className="space-y-3 text-xs text-foreground-600 font-label leading-relaxed">
              <p>
                이 사이트에서 광고되는 상품들은 상환기간은 모두 60일 이상이며 최대 연이율은 20%입니다.
              </p>
              <p>
                상환기간: 12개월~60개월 | 총 대출 비용 예시 : 100만원을 12개월동안 금리 20% 적용하여 원리금균등상환방법으로 이용하는 경우 총 상환금액 1,111,614원
                (단, 대출상품 및 상환방법 등 대출계약 내용에 따라 달라질 수 있습니다)
              </p>
              <p>
                대출금리 연 20%이내(연체금리 최대 20%이내) 단, 2021.07.07부터 체결, 갱신, 연장되는 계약에 한함.
                (연체금리는 약정이자율+3%p 이내 연 20%이내)
                <br />
                소정의 채무증명서 발급 비용외 기타부대 비용과 조기상환조건없음. 단, 담보대출은 부대비용(근저당설정및 해지비용 등)및 조기 사환시 조기상환수수료3%이내.
                <br />
                대출시 귀하의 신용등급 또는 개인신용평점이 하락할 수 있습니다. 중개수수료를 요구하거나 받는것은 불법입니다. 과도한 빚은 당신에게 큰 불행을 안겨줄 수 있습니다.
              </p>
              <p>
                일반금융소비자는 금융판매사업자로부터 충분히 설명을 받을 권리가 있으며, 설명 내용을 이해하신 후 계약 및 금융상품체결 전에 금융상품설명서 및 약관을 읽어보시기 바랍니다.
              </p>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 font-label">
              &copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="/" className="text-xs text-foreground-500 font-label hover:text-primary-600 transition-colors">
                홈
              </a>
              <a href="#consult" className="text-xs text-foreground-500 font-label hover:text-primary-600 transition-colors">
                상담신청
              </a>
              <button
                onClick={() => document.getElementById('policy-modal')?.classList.remove('hidden')}
                className="text-xs text-foreground-500 font-label hover:text-primary-600 transition-colors"
              >
                개인정보처리방침
              </button>
            </div>
          </div>
        </div>
      </footer>

      <div id="policy-modal" className="hidden fixed inset-0 z-[100] bg-foreground-950/50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl md:rounded-3xl w-full max-w-2xl max-h-[80vh] overflow-hidden">
          <div className="flex items-center justify-between p-5 md:p-6 border-b border-background-200/70">
            <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900">개인정보 수집 및 이용 동의</h3>
            <button onClick={closeModal} className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center hover:bg-background-200 transition-colors">
              <i className="ri-close-line w-5 h-5 flex items-center justify-center text-foreground-600" />
            </button>
          </div>
          <div className="p-5 md:p-6 overflow-y-auto max-h-[60vh]">
            <div className="text-sm text-foreground-700 font-label leading-relaxed space-y-4">
              <div>
                <strong className="text-foreground-900 block mb-2">개인정보의 수집 및 이용목적</strong>
                <p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
                <ul className="list-disc pl-5 mt-2 space-y-1 text-foreground-600">
                  <li>서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 컨설팅 및 상담 일체 등</li>
                  <li>회원 관리, 개인 식별, 고지사항 전달 등</li>
                  <li>마케팅 및 광고에 활용, 이벤트 등 광고성 정보 전달 등</li>
                  <li>그 외 서비스 제공에 필요한 전반적인 행정업무 일체</li>
                </ul>
              </div>
              <div>
                <strong className="text-foreground-900 block mb-2">수집하는 개인정보의 항목</strong>
                <p>이름, 핸드폰번호 그 외 선택항목</p>
              </div>
              <div>
                <strong className="text-foreground-900 block mb-2">개인정보의 제3자제공</strong>
                <p>고객이 사전에 회사에 '개인정보 수집 및 이용에 대한 동의'를 동의한 경우, 제공해주신 개인정보가 제휴업체에 제공될 수 있습니다.</p>
              </div>
              <div>
                <strong className="text-foreground-900 block mb-2">개인정보의 보유 및 이용기간</strong>
                <p>원칙적으로 개인정보의 수집 또는 제공받은 목적 달성 시 지체 없이 파기합니다. 다만, 원활한 서비스의 상담을 위해 상담 완료 후 내용을 3개월간 보유할 수 있으며, 전자상거래에서의 소비자보호에 관한 법률 등 타법률에 의해 보존할 필요가 있는 경우에는 일정기간 보존합니다.</p>
              </div>
            </div>
          </div>
          <div className="p-5 md:p-6 border-t border-background-200/70 flex justify-end">
            <button
              onClick={closeModal}
              className="px-6 py-2.5 rounded-xl bg-primary-500 text-white font-label font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </>
  );
}